import { render } from "./AuthAdd.vue?vue&type=template&id=2a2485c4&scoped=true"
import script from "./AuthAdd.vue?vue&type=script&lang=js"
export * from "./AuthAdd.vue?vue&type=script&lang=js"

import "./AuthAdd.vue?vue&type=style&index=0&id=2a2485c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2485c4"]])

export default __exports__